import React from 'react';

import { ColumnsType } from 'antd/es/table';
import styled from 'styled-components';

import SorterIcon from 'common/Sort/SorterIcon';
import { StyledTable } from 'common/Table/StyledTable';

import CommunitiesTableActions from './CommunitiesTableActions';
import CommunitiesTableAddress from './CommunitiesTableAddress';
import CommunitiesTableCommunity from './CommunitiesTableCommunity';
import CommunitiesTableCompany from './CommunitiesTableCompany';
import CommunitiesTableCompetitors from './CommunitiesTableCompetitors';
import { SORT_ORDER } from '../../../constants';
import { useCommunitiesContext } from '../CommunitiesContext';
import { COMMUNITIES_ADMIN_PAGE_SIZE, ORDERING_FIELD } from '../constants';

const CommunitiesStyledTable = styled(StyledTable)`
  &&&&&& {
    .ant-table-pagination.ant-pagination {
      padding-bottom: 12px;
    }
  }
`;

const CommunitiesTable = () => {
  const { loading, filters, setPage, setOrdering, items, totalItemsCount } = useCommunitiesContext();

  const columns: ColumnsType<any> = [
    {
      title: 'COMMUNITY',
      width: 250,
      sorter: true,
      key: ORDERING_FIELD,
      sortIcon: ({ sortOrder }: any) => <SorterIcon sortOrder={sortOrder} />,
      render: (value: any, record: any) => {
        return <CommunitiesTableCommunity item={value} />;
      },
    },
    {
      title: 'COMPANY',
      width: 200,
      render: (value: any, record: any) => {
        return <CommunitiesTableCompany item={value} />;
      },
    },
    {
      title: 'ADDRESS',
      width: 200,
      render: (value: any, record: any) => {
        return <CommunitiesTableAddress item={value} />;
      },
    },
    {
      title: 'COMPETITORS',
      render: (value: any, record: any) => {
        return <CommunitiesTableCompetitors item={value} />;
      },
    },
    {
      title: '',
      render: (value: any, record: any) => {
        return <CommunitiesTableActions item={value} />;
      },
    },
  ];

  return (
    <CommunitiesStyledTable
      columns={columns}
      size={'small'}
      dataSource={items}
      bordered={false}
      loading={loading}
      rowKey={(record: any) => record?.id}
      onChange={(pagination: any, filters: any, sorter: any) => {
        if (sorter?.order && sorter.columnKey) {
          const orderBy = sorter?.order == SORT_ORDER.DESCEND ? `-${sorter.columnKey}` : sorter.columnKey;
          setOrdering(orderBy);
        } else if (!sorter?.order && !sorter?.columnKey) {
          setOrdering(ORDERING_FIELD);
        }
        if (pagination) {
          setPage(pagination.current);
        }
      }}
      pagination={{
        size: 'small',
        position: ['bottomLeft'],
        showSizeChanger: false,
        current: filters.page,
        pageSize: COMMUNITIES_ADMIN_PAGE_SIZE,
        total: totalItemsCount,
        showTotal: (total, range) => {
          const displayedItems = range[1] - range[0] + 1;
          return (
            <span>
              Showing {displayedItems} of {total} records
            </span>
          );
        },
      }}
    />
  );
};

export default CommunitiesTable;
